import styled from 'styled-components';
import { Button } from '../../globalStyles';

export const HeroCarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SloganSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 40px;
  color: white;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 15px;
  }
`;

export const SloganTitle = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  color: #ffffff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const SloganSubtitle = styled.p`
  font-size: clamp(1rem, 2vw, 1.5rem);
  line-height: 1.6;
  color: #e1e4d5;
  margin-bottom: 30px;
  max-width: 500px;

  @media (max-width: 768px) {
    text-align: center;
    max-width: 100%;
  }
`;

export const CarouselSection = styled.div`
  flex: 1;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    height: 60%;
  }
`;

export const HeroSlide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  &.active {
    opacity: 1;
  }

  /* Overlay específico para cada slide */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0.75) 20%,
      rgba(0, 0, 0, 0.6) 35%,
      rgba(0, 0, 0, 0.4) 50%,
      rgba(0, 0, 0, 0.2) 65%,
      rgba(0, 0, 0, 0.05) 80%,
      transparent 100%
    );
    z-index: 2;
    pointer-events: none;
  }
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const HeroSlideContent = styled.div`
  position: relative;
  z-index: 5;
  text-align: left;
  max-width: 600px;
  width: 100%;
  padding: 0 60px;
  color: white;
  margin-right: auto;

  @media (max-width: 980px) {
    padding: 0 50px;
    max-width: 500px;
  }

  @media (max-width: 768px) {
    padding: 0 40px;
    text-align: center;
    max-width: 100%;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    padding: 0 30px;
  }
`;


export const HeroText = styled.div`
  margin-bottom: 35px;
  max-width: 100%;

  h3 {
    font-size: clamp(1rem, 2vw, 1.5rem);
    font-weight: 400;
    margin-bottom: 15px;
    letter-spacing: 1px;
    color: #fff;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.9);

    @media (max-width: 768px) {
      text-align: center;
    }
  }

  h1 {
    font-size: clamp(2rem, 5vw, 4rem);
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.2;
    color: #fff;
    text-shadow: 3px 3px 12px rgba(0, 0, 0, 0.9);

    @media (max-width: 768px) {
      text-align: center;
    }
  }

  p {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    line-height: 1.6;
    color: #ffffff;
    margin-bottom: 25px;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.9);

    @media (max-width: 768px) {
      text-align: center;
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    justify-content: center;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }
`;

export const HeroButton = styled(Button)`
  background: #f8bb59;
  color: white;
  border: 2px solid #f8bb59;
  
  &:before {
    background: #f8bb59;
    height: 500%;
  }
  
  &:hover:before {
    height: 0%;
  }
  
  &:hover {
    color: white;
    background: #f8bb59;
    border: 2px solid #f8bb59;
  }
`;

export const CarouselArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: white;
  font-size: 2.5rem;
  font-weight: bold;
  width: 60px;
  height: 60px;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);

  &:hover {
    color: #ffffff;
    transform: translateY(-50%) scale(1.2);
    text-shadow: 3px 3px 12px rgba(0, 0, 0, 0.9);
  }

  &:active {
    transform: translateY(-50%) scale(1.1);
  }

  &.prev {
    left: 0px;
  }

  &.next {
    right: 0px;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 2rem;

    &.prev {
      left: 10px;
    }

    &.next {
      right: 10px;
    }
  }

  @media (max-width: 480px) {
    width: 45px;
    height: 45px;
    font-size: 1.8rem;

    &.prev {
      left: 5px;
    }

    &.next {
      right: 5px;
    }
  }
`;

export const CarouselDots = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;

  @media (max-width: 768px) {
    bottom: 20px;
  }

  @media (max-width: 480px) {
    bottom: 15px;
  }
`;

export const Dot = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;

  &.active {
    background: white;
    border-color: white;
    transform: scale(1.2);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.8);
  }

  @media (max-width: 480px) {
    width: 10px;
    height: 10px;
  }
`;
